import React from "react";
import Reveal from "../common/Reveal";
import photo from "../imgs/formal_photo.png";

export default function Hero({ photoTreatment = "grayscale" }) {
  return (
    <header className="hero">
      <div className="section-inner">
        <Reveal className="hero-eyebrow">
          <span className="pulse-dot" />
          <span className="hero-eyebrow-text mono">
            John Paulo Guimalan — Software Engineer
          </span>
        </Reveal>
        <div className="hero-row">
          <div className="hero-copy">
            <Reveal as="h1" className="hero-title">
              Backends that scale. Systems that think.
            </Reveal>
            <Reveal as="p" className="hero-sub">
              I've always cared more about what's underneath a product than
              what's on the screen — the architecture, the infrastructure,
              the decisions that decide whether something holds up at scale.
              That's the part of engineering I never get tired of.
            </Reveal>
            <Reveal className="hero-ctas">
              <a href="#projects" className="lnk btn btn-filled mono">
                View work →
              </a>
              <a href="#contact" className="lnk btn btn-ghost mono">
                Get in touch
              </a>
            </Reveal>
            <Reveal className="hero-meta">
              <div>
                <div className="hero-meta-label mono">NOW</div>
                <div className="hero-meta-value">
                  Software Engineer @ Ubiquity Global Services
                </div>
              </div>
              <div>
                <div className="hero-meta-label mono">BASED IN</div>
                <div className="hero-meta-value">Quezon City, PH</div>
              </div>
              <div>
                <div className="hero-meta-label mono">FOCUS</div>
                <div className="hero-meta-value">
                  Backend · DevOps · AI systems
                </div>
              </div>
            </Reveal>
          </div>
          <Reveal
            className={`hero-photo-wrap ${photoTreatment === "natural" ? "natural" : ""}`}
          >
            <img className="hero-photo" src={photo} alt="John Paulo Guimalan" />
            <span className="hero-caption mono">JPG_2026.PORTRAIT</span>
          </Reveal>
        </div>
      </div>
    </header>
  );
}
